<template>
  <div class="container" style="margin-top: 3cm">
    <h2 class="text-center">2025年度四川省企业管理现代化创新成果与优秀论著文入围名单公示</h2>
    <p class="box_p text-center">
      <span>发布时间： </span>
      <span id="date" style="display: inline-block; margin-left: -10px">
         2025-11-28 15:36:33
        </span>
      <span style="margin-left: 16px">编辑： </span>
      <span id="author" style="display: inline-block; margin-left: -10px">
         管理员
        </span>
    </p>
    <div style="letter-spacing:2px">
      各市州及行业企联（企协）、各成果创造单位、有关企业：<br>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为深入学习贯彻习近平新时代中国特色社会主义思想，全面贯彻落实党的二十大精神，切实推进管理创新，加快企业高质量发展，根据国家工信部、国资委和中企联对管理创新工作的部署，四川省企业联合会/企业家协会、四川企联管理创新工作委员会在各市州及行业企联（企协）及广大企业的共同努力下，开展了2025年度企业管理现代化创新成果与企业管理论（著）文的培育、申报、推荐、审定等工作。经四川企联企业管理现代化创新成果审定委员会组织有关专家进行认真科学评价并最终审定，2025年度189项成果被审定为“年度四川省级企业管理现代化创新成果”，105篇论（著）文被审定为“年度四川省级企业管理优秀论（著）文”，现予以发布。
      四川省级企业管理现代化创新成果和论文，反映了不同时期企业经营管理的最新路径、优秀经验，是企业管理者在企业发展过程中勇于开拓、敢于创新、勤于实践的智慧结晶，对各行业企业提升管理水平、实现转型升级起到了良好的示范和引导作用。请各成果创造单位进一步加强成果在本单位和本行业系统的推广应用，并结合企业实际情况，参照科技成果奖励办法，对主创人及参与创造人给予奖励。<br><br>
      四川省企业联合会 四川省企业家协会<br>
      2025年11月28日<br><br>
      <dl>
        <dt>附件下载：</dt>
        <dd><a style="color: #1c84c6" href="static/file/关于发布2025年度四川省企业管理现代化创新成果的通知.pdf" download>关于发布2025年度四川省企业管理现代化创新成果的通知</a></dd>
        <dd><a style="color: #1c84c6" href="static/file/关于发布2025年度四川省企业管理优秀论(著)文的通知.pdf" download>关于发布2025年度四川省企业管理优秀论(著)文的通知</a></dd>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/NoticeDetails1.vue